/* eslint-disable @typescript-eslint/naming-convention */
export const APP_CONSTANTS = Object.freeze({
  PWA_VERSION: '2.0.0',
  SUPPORT_PHONE: '',
  BLOG_URL: '',

  PASSWORD_PATTERN: /[\d\-_#$%&*]/g,
  // EMAILPATTERN:
  //   /^[a-z0-9!#$%&'*\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])+)+$/i,
  EMAILPATTERN: /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])+)+$/i,
  CREDIT_CARD_PATTERN: /^([0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4})$/,
  CREDIT_CARD_MASK: '9999-9999-9999-9999',
  PHONE_PATTERN: /^(\([0-9]{3}\)-[0-9]{3}-[0-9]{4})$/,
  PHONE_MASK: '(999)-999-9999',
  ONLY_LETTERS_PATTERN: /^[a-zA-ZÀ-ȕ ]+$/,

  VALIDATION_MESSAGES: {
    userFullName: [
      { type: 'required', message: 'FORM.FEEDBACK.required' },
      { type: 'pattern', message: 'FORM.FEEDBACK.onlyLetters' },
    ],
    title: [{ type: 'required', message: 'FORM.FEEDBACK.required' }],
    name: [
      { type: 'required', message: 'FORM.FEEDBACK.required' },
      { type: 'pattern', message: 'FORM.FEEDBACK.onlyLetters' },
    ],
    last_name: [
      { type: 'required', message: 'FORM.FEEDBACK.required' },
      { type: 'pattern', message: 'FORM.FEEDBACK.onlyLetters' },
    ],
    email: [
      { type: 'required', message: 'FORM.FEEDBACK.required' },
      { type: 'pattern', message: 'FORM.FEEDBACK.wrongFormat' },
    ],
    password: [{ type: 'required', message: 'FORM.FEEDBACK.required' }],
    phone: [
      { type: 'required', message: 'FORM.FEEDBACK.required' },
      { type: 'pattern', message: 'FORM.FEEDBACK.onlyNumbers' },
      {
        type: 'minlength',
        message: 'FORM.FEEDBACK.exactlyXDigits',
        params: '{x:10}',
      },
      {
        type: 'maxlength',
        message: 'FORM.FEEDBACK.exactlyXDigits',
        params: '{x:10}',
      },
    ],
    mobile: [
      { type: 'required', message: 'FORM.FEEDBACK.required' },
      { type: 'pattern', message: 'FORM.FEEDBACK.onlyNumbers' },
      {
        type: 'minlength',
        message: 'FORM.FEEDBACK.exactlyXDigits',
        params: '{x:10}',
      },
      {
        type: 'maxlength',
        message: 'FORM.FEEDBACK.exactlyXDigits',
        params: '{x:10}',
      },
    ],
    place: [{ type: 'required', message: 'FORM.FEEDBACK.required' }],
    datetime_from: [{ type: 'required', message: 'FORM.FEEDBACK.required' }],
    datetime_to: [{ type: 'required', message: 'FORM.FEEDBACK.required' }],
    address: [{ type: 'required', message: 'FORM.FEEDBACK.required' }],
  },

  firebaseConfigForGMB: {
    apiKey: 'AIzaSyAaYjCH3fax7WwWJ8KXlNPh5yaOrXwIGZo',
    authDomain: 'virket-gmb-agency.firebaseapp.com',
    projectId: 'virket-gmb-agency',
    storageBucket: 'virket-gmb-agency.appspot.com',
    messagingSenderId: '469583761824',
    appId: '1:469583761824:web:b0f899616430c8513714c5',
    measurementId: 'G-SX1SWYF9CS',
  },
  gcpWebClientId:
    '469583761824-6thjrhethh9h9luqoph2pg45h8pq16s7.apps.googleusercontent.com',
  //'469583761824-8head6ttaiddl8432peoidp88jh1vipl.apps.googleusercontent.com',
  gcpAndroidClientId:
    '469583761824-8qjkng4av4a8g204en9fusphksub5bb2.apps.googleusercontent.com',
});

export interface IAvailableLanguages {
  code: string;
  translations: { en: string; es: string };
}
